import { PortalWithState } from 'react-portal';
import PropTypes from 'prop-types';
import React from 'react';

import PagePreview from './Component';
import PrintStyles from 'components/misc/printStyles';

const PrintPreview = ({ content, setPrintPreview }) => {

    return (
        <React.Fragment>
            <PrintStyles />
            <PortalWithState closeOnEsc defaultOpen onClose={
                () => setPrintPreview(false)
            }>
                {({ closePortal, portal /* isOpen, openPortal */ }) => portal(
                    <PagePreview content={content} onClose={closePortal} />
                )}
            </PortalWithState>
        </React.Fragment>
    );
};

PrintPreview.propTypes = {
    content: PropTypes.element,
    setPrintPreview: PropTypes.func,
};

export default PrintPreview;
